import { useNavigate } from 'react-router';
import { AccessDeniedScreen } from './access';

/**
 * Renders the package-provided AccessDeniedScreen. `onUnlock` navigates to '/', which
 * re-runs rootLoader → re-checks access → mounts the App once the check passes (no page
 * reload). accessDeniedLoader already guarantees AccessDeniedScreen exists on this route.
 */
export function AccessDeniedRoute() {
    const navigate = useNavigate();

    // Defensive: the route loader redirects away when the screen is absent.
    if (!AccessDeniedScreen) {
        return null;
    }

    return <AccessDeniedScreen onUnlock={() => navigate('/')} />;
}
